(function () {
  const overlay   = document.getElementById('colorVideoModal');
  const player    = document.getElementById('colorVideoPlayer');
  const closeBtn  = document.getElementById('colorVideoClose');
  const thumbsBar = document.getElementById('colorVideoThumbs');
  const titleEl   = document.getElementById('colorVideoTitle');

  if (!overlay || !player || !thumbsBar) return;

  let currentVideos = [];
  let activeIndex = 0;

  const playSVG = '<svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg"><polygon points="8 5 19 12 8 19 8 5"/></svg>';

  function buildThumbs(videos) {
    thumbsBar.innerHTML = '';
    videos.forEach(function (url, i) {
      var thumb = document.createElement('div');
      thumb.className = 'video-thumb' + (i === 0 ? ' is-active' : '');
      thumb.dataset.index = i;

      var tv = document.createElement('video');
      tv.src = url + '#t=0.5'; tv.muted = true; tv.preload = 'metadata'; tv.playsInline = true; tv.tabIndex = -1;

      var ov = document.createElement('div');
      ov.className = 'video-thumb__play'; ov.innerHTML = playSVG;

      var ix = document.createElement('span');
      ix.className = 'video-thumb__index'; ix.textContent = i + 1;

      thumb.append(tv, ov, ix);
      thumb.addEventListener('click', function () { selectVideo(i); });
      thumbsBar.appendChild(thumb);
    });
  }

  function selectVideo(index) {
    activeIndex = index;
    thumbsBar.querySelectorAll('.video-thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    var active = thumbsBar.querySelector('.video-thumb.is-active');
    if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    var wasPlaying = !player.paused;
    player.src = currentVideos[index];
    player.load();
    if (wasPlaying || index !== 0) player.play().catch(function () {});
  }

  function openModal(videos, colorName, startIndex) {
    startIndex = startIndex || 0;
    currentVideos = videos;
    activeIndex = startIndex;
    if (titleEl && colorName) titleEl.textContent = colorName;
    buildThumbs(videos);
    selectVideo(startIndex);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    player.pause();
    player.src = '';
    thumbsBar.innerHTML = '';
    currentVideos = [];
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') selectVideo((activeIndex + 1) % currentVideos.length);
    if (e.key === 'ArrowLeft')  selectVideo((activeIndex - 1 + currentVideos.length) % currentVideos.length);
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });

  /* ── Detectar color activo del swatch seleccionado ── */
  function getActiveColor(card) {
    /* Prestige/Kaya theme: color swatches are <label class="color-swatch is-selected">
       with data-tooltip="ColorName" and <span class="sr-only">ColorName</span> inside */
    var el = card.querySelector('.color-swatch.is-selected');
    if (el) {
      return el.dataset.tooltip || (el.querySelector('.sr-only') ? el.querySelector('.sr-only').textContent.trim() : null);
    }
    /* Fallback: check the checked radio input that drives the swatch */
    var checked = card.querySelector('.product-card__info input[type="radio"]:checked');
    if (checked) {
      var label = card.querySelector('label[for="' + checked.id + '"]');
      if (label) {
        return label.dataset.tooltip || (label.querySelector('.sr-only') ? label.querySelector('.sr-only').textContent.trim() : null);
      }
    }
    /* Fallback: data-active-color attribute (product-card-color cards) */
    if (card.dataset.activeColor) {
      return card.dataset.activeColor;
    }
    return null;
  }

  /* ── Helpers para verificar videos del color activo ── */
  function getVideosForColor(card) {
    var videosMap = {};
    try { videosMap = JSON.parse(card.dataset.colorVideos || '{}'); } catch (_) { return []; }
    var activeColor = getActiveColor(card);
    if (!activeColor || !videosMap[activeColor]) return [];
    var videos = videosMap[activeColor];
    var arr = Array.isArray(videos) ? videos : [videos];
    return arr.length ? arr : [];
  }

  /* ── Click en botón de video ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-trigger]');
    if (!btn) return;

    var card = btn.closest('[data-color-videos]');
    if (!card) return;

    var activeColor = getActiveColor(card);
    var arr = getVideosForColor(card);

    if (arr.length) {
      openModal(arr, activeColor);
    }
  });

  /* ── Actualizar estado del botón al cambiar swatch ── */
  function updateVideoBtn(card) {
    var btn = card.querySelector('[data-video-trigger]');
    if (!btn) return;

    var activeColor = getActiveColor(card);
    var arr = getVideosForColor(card);

    btn.toggleAttribute('data-no-video', arr.length === 0);
    btn.title = arr.length
      ? 'Ver ' + arr.length + ' video' + (arr.length > 1 ? 's' : '') + ' \u2014 ' + activeColor
      : 'Sin video para este color';
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.color-swatch');
    if (!swatch) return;

    var card = swatch.closest('[data-color-videos]');
    if (!card) return;

    setTimeout(function () { updateVideoBtn(card); }, 50);
  });

  /* ── Inicializar estado de todos los botones al cargar ── */
  function initAllVideoBtns() {
    document.querySelectorAll('[data-color-videos]').forEach(function (card) {
      updateVideoBtn(card);
    });
  }

  /* Ejecutar inmediatamente por si el DOM ya está listo */
  initAllVideoBtns();

  /* Ejecutar también en DOMContentLoaded para cards que aún no estaban listas */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVideoBtns);
  }

  /* Ejecución diferida para custom elements (<product-card>) que se inicializan
     después del DOM ready (ej. variantes por color en colecciones) */
  requestAnimationFrame(function () {
    setTimeout(initAllVideoBtns, 200);
  });
})();

/* ============================================================
   KAYA UX MOBILE IMPROVEMENTS
   ============================================================ */
(function () {
  'use strict';

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  /* ── 3. Chat bubble: aparición diferida (3s o tras 30% scroll) ── */
  function setupChatBubbleReveal() {
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      document.body.classList.add('kaya-chat-ready');
      window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      var doc = document.documentElement;
      var scrolled = (doc.scrollTop || document.body.scrollTop) /
                     Math.max(1, doc.scrollHeight - doc.clientHeight);
      if (scrolled >= 0.3) reveal();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(reveal, 3500);
  }

  /* ── 3. Chat bubble: subir cuando hay sticky bar visible / esconder con drawer abierto ── */
  function setupChatBubblePosition() {
    if (!isMobile()) return;

    /* Sticky-bar producto */
    function watchStickyBar() {
      var stickyBar = document.querySelector('.product-sticky-bar');
      if (!stickyBar) return;
      var apply = function () {
        document.body.classList.toggle(
          'kaya-sticky-active',
          stickyBar.classList.contains('is-visible')
        );
      };
      apply();
      var mo = new MutationObserver(apply);
      mo.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
    }

    /* Drawer abierto (cart, header sidebar, dialog) */
    function watchOverlays() {
      var apply = function () {
        var anyOpen = !!document.querySelector(
          'cart-drawer[open], header-sidebar[open], drawer[open], dialog[open], .drawer.is-open, .modal.is-open'
        );
        document.body.classList.toggle('kaya-overlay-open', anyOpen);
      };
      apply();
      var mo = new MutationObserver(apply);
      mo.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open', 'class', 'aria-hidden']
      });
    }

    watchStickyBar();
    watchOverlays();
  }

  /* ── 2. Drawer: auto-expand HOMBRE/MUJER según división activa al abrir ── */
  function setupDrawerAutoExpand() {
    function detectActiveDivision() {
      var path = (window.location.pathname || '').toLowerCase();
      if (path.indexOf('/pages/hombre') >= 0) return 'hombre';
      if (path.indexOf('/pages/mujer') >= 0) return 'mujer';
      if (path.indexOf('/pages/accesorios') >= 0) return 'accesorios';
      var qs = (window.location.search || '').toLowerCase();
      var m = qs.match(/division=(hombre|mujer|accesorios|bodega)/);
      if (m) return m[1];
      return null;
    }

    function expandDivisionInDrawer(drawer) {
      var division = detectActiveDivision();
      if (!division) return;

      var buttons = drawer.querySelectorAll(
        '.header-sidebar__main-panel .header-sidebar__linklist [aria-controls]'
      );
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var text = (btn.textContent || '').trim().toLowerCase();
        if (text === division || text.indexOf(division) === 0) {
          if (btn.getAttribute('aria-expanded') !== 'true') {
            btn.click();
          }
          break;
        }
      }
    }

    document.addEventListener('dialog:after-show', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('header-sidebar')) return;
      setTimeout(function () { expandDivisionInDrawer(t); }, 250);
    });
  }

  /* ── 2. Drawer: marcar item Despacho Express como destacado ── */
  function highlightExpressInDrawer() {
    var links = document.querySelectorAll(
      '.header-sidebar__main-panel .header-sidebar__linklist a, ' +
      '.header-sidebar__main-panel .header-sidebar__linklist button'
    );
    links.forEach(function (el) {
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt.indexOf('despacho') >= 0 || txt.indexOf('express') >= 0) {
        el.classList.add('is-featured-express');
      }
    });
  }

  /* ── 5. Selected sort label en collection toolbar (cliente) ── */
  function injectSelectedSortLabel() {
    var sortBtn = document.querySelector('.collection-toolbar__button[aria-controls="sort-by-popover"]');
    if (!sortBtn || sortBtn.querySelector('.kaya-selected-sort')) return;
    var popover = document.getElementById('sort-by-popover');
    if (!popover) return;
    var selected = popover.querySelector('[role="option"][aria-selected="true"]');
    if (!selected) return;
    var label = (selected.textContent || '').trim();
    if (!label) return;
    var span = document.createElement('span');
    span.className = 'kaya-selected-sort';
    span.textContent = '· ' + label;
    var holder = sortBtn.querySelector('.text-with-icon') || sortBtn;
    var chevron = holder.querySelector('svg');
    if (chevron) holder.insertBefore(span, chevron);
    else holder.appendChild(span);
  }

  /* ── 5. Filtros: convertir "(N)" en pill visual ── */
  function pillifyFilterCount() {
    var filterBtn = document.querySelector('.collection-toolbar__button[aria-controls="facets-drawer"]');
    if (!filterBtn || filterBtn.querySelector('.kaya-active-count')) return;
    var html = filterBtn.innerHTML;
    var m = html.match(/\(\s*(\d+)\s*\)/);
    if (m) {
      filterBtn.innerHTML = html.replace(
        m[0],
        ' <span class="kaya-active-count">' + m[1] + '</span>'
      );
    }
  }

  /* ── 7. Free-shipping-bar progress bar visual ── */
  function setupShippingProgress() {
    document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
      if (bar.querySelector('.kaya-shipping-progress')) return;
      var threshold = parseFloat(bar.getAttribute('threshold')) || 0;
      var total = parseFloat(bar.getAttribute('total-price')) || 0;
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;
      var wrap = document.createElement('div');
      wrap.className = 'kaya-shipping-progress' + (pct >= 100 ? ' kaya-shipping-progress--reached' : '');
      wrap.style.setProperty('--kaya-shipping-pct', pct + '%');
      wrap.innerHTML = '<span class="kaya-shipping-progress__fill"></span>';
      bar.appendChild(wrap);

      /* Re-render on attribute change */
      var mo = new MutationObserver(function () {
        var t = parseFloat(bar.getAttribute('threshold')) || 0;
        var p = parseFloat(bar.getAttribute('total-price')) || 0;
        var newPct = t > 0 ? Math.min(100, (p / t) * 100) : 0;
        wrap.style.setProperty('--kaya-shipping-pct', newPct + '%');
        wrap.classList.toggle('kaya-shipping-progress--reached', newPct >= 100);
      });
      mo.observe(bar, { attributes: true, attributeFilter: ['threshold', 'total-price'] });
    });
  }

  /* ── 8. Cart page: toggle de cart note ── */
  function setupCartNoteToggle() {
    var toggle = document.querySelector('.cart-page .kaya-toggle-note');
    var note = document.querySelector('.cart-page .cart-note');
    if (!toggle || !note) return;
    if (note.querySelector('textarea') && note.querySelector('textarea').value.trim()) {
      note.classList.add('is-open');
      toggle.classList.add('is-open');
    }
    toggle.addEventListener('click', function () {
      var open = note.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var ta = note.querySelector('textarea');
        if (ta) ta.focus();
      }
    });
  }

  function init() {
    setupChatBubbleReveal();
    setupChatBubblePosition();
    setupDrawerAutoExpand();
    highlightExpressInDrawer();
    injectSelectedSortLabel();
    pillifyFilterCount();
    setupShippingProgress();
    setupCartNoteToggle();

    /* Re-bind on dynamic content (cart updates, section re-render) */
    document.addEventListener('cart:change', function () {
      setTimeout(setupShippingProgress, 50);
    });
    document.addEventListener('shopify:section:load', function () {
      highlightExpressInDrawer();
      injectSelectedSortLabel();
      pillifyFilterCount();
      setupShippingProgress();
      setupCartNoteToggle();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
